import { render, staticRenderFns } from "./ElementTestimonial.vue?vue&type=template&id=356cccea&"
import script from "./ElementTestimonial.vue?vue&type=script&lang=js&"
export * from "./ElementTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports